import { forwardRef, useRef } from 'react'
import GameObject from './GameObject'

const Image = forwardRef(({
  args,
  children,
  ...props
}, externalRef) => {

  const localRef = useRef()
  const ref = externalRef || localRef

  return (
    <GameObject
      ref={ref}
      type="Image"
      args={args}
      {...props}
    />
  )
})

Image.displayName = 'Image'
export default Image
